const cloneDeep = (value: any): any => {
    if (!value) {
        return value;
    }
    return JSON.parse(JSON.stringify(value));
};

export { cloneDeep };
